import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { Overlay } from "@/components/ui/overlay";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import FingerBreathFlow from "@/components/Exercises/Breathing/FingerBreathFlow";
import fingerBreathIntro from "@/assets/audios/Fingers-breathing-exercise-introduction.m4a";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import ConfirmationModal from "@/components/ui/confirmation-modal";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/finger-breathing/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Finger Breathing Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "breathing.fingerBreath.title",
    navbar: {
      showTitle: true,
    },
  }),
});
function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };

  const handleCloseRequest = () => {
    setShowExitModal(true);
  };

  const handleExitConfirm = () => {
    setShowExitModal(false);
    closeOverlay();
  };

  const handleExitCancel = () => {
    setShowExitModal(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="breathing.startExercise" />
        </Button>
      }
    >
      <p className="text-small">
        <FormattedMessage id="breathing.fingerBreath.intro" />
      </p>

      <MediaPlayer src={fingerBreathIntro} isPaused={isPausedAudio} />

      <Overlay show={showOverlay} onClose={handleCloseRequest}>
        <FingerBreathFlow onComplete={closeOverlay} />
      </Overlay>

      <ConfirmationModal
        isOpen={showExitModal}
        onClose={handleExitCancel}
        onConfirm={handleExitConfirm}
        titleKey="exercise.exit.title"
        messageKey="exercise.exit.message"
        confirmButtonTextKey="exercise.exit.confirm"
      />
    </ExerciseLayout>
  );
}
